// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import {Dictionary} from '../../../shared/models/dictionary.model';
import {IBaseType} from '../../../shared/enums/ibase-type.enum';

export interface IOdometerReadingType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class OdometerReadingType implements IOdometerReadingType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Actual OdometerReadingType
	**/
    get Actual(): IOdometerReadingType {
        return this.FromId(1);
    }
    /**
		Returns Not Actual OdometerReadingType
	**/
    get NotActual(): IOdometerReadingType {
        return this.FromId(2);
    }
    /**
		Returns Exceeds Mechanical Limits OdometerReadingType
	**/
    get ExceedsMechanicalLimits(): IOdometerReadingType {
        return this.FromId(3);
    }

    /**
		Returns Unknown OdometerReadingType
	**/
    get Unknown(): IOdometerReadingType {
        return this.FromId(4);
    }

    get Exempt(): IOdometerReadingType {
        return this.FromId(5);
    }
    get NoODO(): IOdometerReadingType {
        return this.FromId(6);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'Actual', displayValue: 'Actual', description: 'Reading value is the actual miles for the vehicle', sortOrder: 1, active: true });
        this._dictionary.add('2', { id: 2, value: 'Not Actual', displayValue: 'Not Actual', description: 'Reading value is not the actual miles for the vehicle', sortOrder: 2, active: true });
        this._dictionary.add('3', { id: 3, value: 'Exceeds Mechanical Limits', displayValue: 'Exceeds Mechanical Limits', description: 'Reading value exceeds the mechanical limits for the vehicle', sortOrder: 3, active: true });
        this._dictionary.add('4', { id: 4, value: 'Unknown', displayValue: 'Unknown', description: 'Reading type is not available', sortOrder: 999999, active: false });
        this._dictionary.add('5', { id: 5, value: 'Exempt', displayValue: 'Exempt', description: 'Exempt', sortOrder: 999999, active: true });
        this._dictionary.add('6', { id: 6, value: 'NoODO', displayValue: 'No ODO', description: 'Odometer Reading value is 0', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IOdometerReadingType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IOdometerReadingType {
        var match = this._dictionary.getValues().filter(function(data) {
            return data.value == value;
        });

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IOdometerReadingType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IOdometerReadingType[] {
        return this.GetAll().filter(function(data) {
            return data.active;
        });
    }

    public Sort(primaryField, secondaryField, reverse): IOdometerReadingType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = function(path, reverse, primer, then) {
        var get = function(obj, path) {
                if (path) {
                    path = path.split('.');
                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }
                    return obj[path[len]];
                }
                return obj;
            },
            prime = function(obj) {
                return primer ? primer(get(obj, path)) : get(obj, path);
            };

        return function(a, b) {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
